import React, { memo, useState } from "react";
import LisrProduction from "../company/LisrProduction";
import ApiData from "../../api/ApiData";
import Loader from "../Loader";
import { observer } from "mobx-react-lite";
import { ContainerSubTitleGrey } from "../ContainerSubTitleGrey";
import NewProduction from "./NewProduction";
import ThisProduction from "./ThisProduction";
import RolesState from "../../api/RolesState";
import { BtnPrimaryv4 } from "../UI/button/BtnPrimaryv4";
import { DashCard } from "../UI/DashCard";

const Productions = observer(({ getSoftProductionFunc }) => {
  const moveSoftProductionFunc = (e) => {
    ApiData.thisProduction(e.id);
    setFlagThisModalProduction(true);
  };

  const [flagNewModalProduction, setFlagNewModalProduction] = useState(false);
  const [flagThisModalProduction, setFlagThisModalProduction] = useState(false);

  const productionCount = Array.isArray(ApiData.company.productions)
    ? ApiData.company.productions.length
    : 0;

  return (
    <DashCard
      className="sites-panel production-container-card-company"
      title="Площадки:"
      headerClassName="production-title-bar_container"
      headerActions={
        RolesState.post_production ? (
          <BtnPrimaryv4 onClick={() => setFlagNewModalProduction(true)} />
        ) : null
      }
    >
      {!flagNewModalProduction ? (
        <>
          {ApiData.company.productions !== null ? (
            <>
              {ApiData.company.productions === undefined ? (
                <ContainerSubTitleGrey text="Не добавлено ни одной площадки" />
              ) : (
                <>
                  {!flagThisModalProduction ? (
                    <LisrProduction
                      getSoftProductionFunc={getSoftProductionFunc}
                      moveSoftProductionFunc={moveSoftProductionFunc}
                    />
                  ) : (
                    <ThisProduction
                      setFlagThisModalProduction={setFlagThisModalProduction}
                    />
                  )}
                </>
              )}
            </>
          ) : (
            <Loader />
          )}
          {ApiData.company.productions !== null &&
          ApiData.company.productions !== undefined &&
          !flagThisModalProduction &&
          !flagNewModalProduction ? (
            <div className="sites-panel-footer">
              Всего площадок: {productionCount}
            </div>
          ) : null}
        </>
      ) : (
        <NewProduction setFlagNewModalProduction={setFlagNewModalProduction} />
      )}
    </DashCard>
  );
});

export default memo(Productions);
